import getCountries from './get-countries';
import getFieldValuesFromSettings from './get-field-values-from-settings';
import getLanguageData from './get-language-data';
import getLanguages from './get-languages';
import getSettingValueFromFieldValue from './get-setting-value-from-field-value';
import validateUrl from './validate-url';
import getFileName from './get-file-name';
import validateString from './validate-string';
import getRelatedLanguageOptions from './get-related-language-options';
import getLanguageCodes from './get-language-codes';
import updateLanguageSelector from './update-language-selector';
import setAndSaveActivePageOnLocaleAdd from './set-and-save-active-page-on-locale-add';

export default {
  getCountries,
  getFieldValuesFromSettings,
  getLanguageData,
  getLanguages,
  getSettingValueFromFieldValue,
  validateUrl,
  getFileName,
  validateString,
  getRelatedLanguageOptions,
  getLanguageCodes,
  updateLanguageSelector,
  setAndSaveActivePageOnLocaleAdd,
};
